import React, { FC } from 'react';

import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';

const Logo = styled.div`
  .st0 {
    fill: none;
  }
  .st1 {
    fill: #005aaa;
  }
  .st3 {
    font-size: 92.4141px;
  }
  .st5 {
    fill: #ed1c24;
  }
  .st6 {
    margin-top: 45px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.PHONE}) {
    width: 165px;
    margin-left: -5px;
    margin-top: -15px;
  }

  @media screen and (max-width: ${BREAK_POINTS.MIN.PHONE_MINIMUM}) {
    width: 140px;
    margin-left: -5px;
    margin-top: -20px;
  }
`;
const CebLogo: FC = () => (
  <Logo>
    <svg className="st6" id="????_1" version="1.1" viewBox="0 0 841.9 595.3" x="0px" y="0">
      <rect className="st0" height="87.1" width="516.2" x="261.1" y="197.8" />
      <text transform="matrix(1 0 0 1 261.1161 266.1977)">
        <tspan className="st1 st3" fontFamily="Panton-ExtraBold" x="0" y="0">
          CEB
        </tspan>
        <tspan className="st1 st3" fontFamily="Panton-SemiBold" x="174" y="0">
          connect
        </tspan>
      </text>
      <g>
        <path
          className="st1"
          d="M144,210.2c-14.8,15.3-11.6,40.7,5.4,51.9c0.6,0.4,1.3,0.3,1.8-0.2c3.6-3.5,6.6-6.9,9.2-11.1
    c0.4-0.7,0.2-1.5-0.5-1.9c-2.6-1.4-5.2-4-6.6-6.8l0,0c-1.7-3.5-2.3-7.3-1.4-11.3c0,0,0,0,0,0c1.1-5.1,6.5-9.9,10.7-14.3
    c0,0,0,0,0,0l15.7-16c6.3-6.4,16.6-6.4,22.9-0.1c6.4,6.3,6.5,16.6,0.2,23l-9.5,9.8c-0.4,0.5-0.6,1.1-0.4,1.7
    c2.2,6.4,2.7,15.3,1.3,22.1c0,0.2,0.2,0.3,0.3,0.2l20.3-20.7c12.9-13.2,12.8-34.7-0.2-47.8c-13.3-13.3-35.1-13.2-48.3,0.2
    L144,210.2C144,210.2,144,210.2,144,210.2L144,210.2z"
        />
        <path
          className="st5"
          d="M181.8,265.1C181.8,265.1,181.8,265.1,181.8,265.1C181.8,265.1,181.9,265.1,181.8,265.1
    c4.2-7.6,5-16.2,3-24.7l0,0l0,0c-1.8-7.5-6.9-15-13.7-19.6c-0.6-0.4-1.5-0.3-2.1,0.1c-3.5,2.8-6.9,6.4-9.1,11
    c-0.4,0.7-0.1,1.6,0.6,2c2.6,1.5,5,3.7,6.5,6.7l0,0c1.2,2.1,2.4,6,1.7,10.2c0,0,0,0,0,0c-0.7,5.6-6.4,10.8-10.9,15.4l0,0
    c-3.4,3.5-12.1,12.4-15.6,15.9c-6.3,6.4-16.6,6.5-23,0.2c-6.4-6.3-6.5-16.6-0.2-23l9.5-9.8c0.4-0.4,0.6-1.1,0.4-1.7
    c-2.1-6.5-2.7-15.3-1.4-22c0-0.2-0.2-0.3-0.3-0.2L107.2,246c-13.1,13.3-13,35.1,0.2,48.3c13.3,13.1,34.9,12.8,48-0.5
    C160.1,288.7,179.5,270.7,181.8,265.1L181.8,265.1z"
        />
      </g>
    </svg>
  </Logo>
);

export default CebLogo;
